import { Link } from "react-router-dom";
import { ArrowRight, Globe2 } from "lucide-react";
import { GEOPOLITICS_ITEMS } from "@/data/indiaContent";

const toneBorder = { saffron: "border-l-[var(--saffron)]", green: "border-l-[var(--india-green)]", chakra: "border-l-[var(--chakra)]" };

export function GeopoliticsSection() {
  return (
    <section id="geopolitics" className="relative z-10 scroll-mt-24 py-20" data-testid="geopolitics-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <p className="eyebrow text-[var(--chakra)]">राष्ट्र प्रथम · भू-राजनीति</p>
            <h2 className="mt-3 font-serif text-3xl font-bold tracking-tight text-[var(--chakra-deep)] sm:text-4xl">India & the World</h2>
            <p className="mt-4 text-base text-stone-600 md:text-lg">
              A nation-first lens on geopolitics: how Bharat secures its borders, builds its partnerships and speaks for the Global South.
            </p>
          </div>
          <Link to="/articles?category=geopolitics" data-testid="geopolitics-articles-link" className="group inline-flex items-center gap-2 rounded-full bg-[var(--chakra)] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--chakra-deep)]">
            <Globe2 className="h-4 w-4" /> Geopolitics articles <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {GEOPOLITICS_ITEMS.map((g, i) => (
            <div key={g.title} data-testid={`geopolitics-card-${i}`} className={`card-lift rounded-2xl border border-[var(--line)] border-l-4 bg-white p-6 ${toneBorder[g.tone]}`}>
              <p className="font-devanagari text-base text-[var(--saffron-deep)]">{g.hindi}</p>
              <h3 className="mt-1 font-serif text-xl font-semibold text-[var(--chakra-deep)]">{g.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone-600">{g.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
